/**
 * Generate a 6-character alphanumeric access code
 * Format: A-Z, 0-9 (uppercase letters and numbers)
 * Example: "A3B9K2"
 */
export const generateAccessCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};
